import PaymentBubble from '../PaymentBubble';
import { PaymentBubbleCommonProps } from '../types';

export default function SubmallNotFoundBubble({
  history
}: PaymentBubbleCommonProps) {
  return (
    <PaymentBubble error>
      <PaymentBubble.Title>파트너 정산계좌 미등록</PaymentBubble.Title>
      <PaymentBubble.Content>
        파트너가 입금 받을 계좌를 등록하지 않았습니다. 등록이 완료되면
        정상적으로 거래가 진행됩니다. 잠시 뒤 다시 시도해주세요.
      </PaymentBubble.Content>
    </PaymentBubble>
  );
}
